import { IntlFormatters } from 'react-intl';
import * as yup from 'yup';
import { getBasicEmailValidation } from '../../../../validations/user/userCommonValidations';
import messages from '../../messages';

export interface ILoginFormData {
  email: string;
  password: string;
}

export interface ISSOLoginFormData extends Omit<ILoginFormData, 'password'> {}

export enum FormFieldNames {
  Email = 'email',
  Password = 'password',
}

export const defaultValues: ILoginFormData = {
  email: '',
  password: '',
};

export function getLoginFormValidationSchema({
  formatMessage,
  isPasswordMandatory,
}: {
  formatMessage: IntlFormatters['formatMessage'];
  isPasswordMandatory: boolean;
}) {
  return yup.object().shape({
    [FormFieldNames.Email]: getBasicEmailValidation(
      formatMessage(messages.authLoginEmailInvalid),
      formatMessage(messages.authLoginEmailRequired)
    ),
    [FormFieldNames.Password]: isPasswordMandatory
      ? yup.string().required(formatMessage(messages.authLoginPasswordRequired))
      : yup.string(),
  });
}
